import { ConfigItem, FilterTypes, OptionsSortType } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import {
	Wastestream,
	WastestreamFilterFields,
	WastestreamSearchResultFields
} from 'Portals/Customer/entities'

export const searchConfig: Wastestream.Search.Config = {
	[WastestreamSearchResultFields.wastestreamId]: {
		label: 'Wastestream ID',
		apiFieldName: WastestreamSearchResultFields.wastestreamId,
		apiSearchFieldName: 'WastestreamId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id,
		UrlParamLabel: UrlParamsLabel.manifestIdLabel,
		isLabelAndId: true,
		optionsSortType: OptionsSortType.byId
	},
	[WastestreamSearchResultFields.wastestreamName]: {
		label: 'Wastestream Name',
		apiFieldName: WastestreamSearchResultFields.wastestreamName,
		apiSearchFieldName: 'WastestreamId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.name,
		UrlParamLabel: UrlParamsLabel.manifestNameLabel,
		isLabelAndId: true,
		optionsSortType: OptionsSortType.byId
	}
}

export const refCodeSearchConfig: Record<string, ConfigItem<string>> = {
	[WastestreamSearchResultFields.refCode]: {
		label: 'Ref Code',
		apiFieldName: WastestreamSearchResultFields.refCode,
		apiSearchFieldName: WastestreamFilterFields.refCode,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.refCode
	}
}

export const supplierLocationSearchConfig: Record<string, ConfigItem<string>> = {
	[WastestreamSearchResultFields.supplierLocation]: {
		label: 'Supplier Location',
		apiFieldName: WastestreamSearchResultFields.supplierLocation,
		apiSearchFieldName: WastestreamFilterFields.supplierLocation,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.supplierLocationName
	}
}

export const filtersConfig: Wastestream.Filter.Config = {
	[WastestreamFilterFields.serviceSite]: {
		label: 'Service Site:',
		apiFilterFieldName: WastestreamFilterFields.serviceSite,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	},
	[WastestreamFilterFields.refCode]: {
		label: 'Ref Code:',
		apiFilterFieldName: WastestreamFilterFields.refCode,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.refCodeFilter,
		defaultValue: ''
	},
	[WastestreamFilterFields.supplierLocation]: {
		label: 'Supplier Location:',
		apiFilterFieldName: WastestreamFilterFields.supplierLocation,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.supplierLocationId,
		defaultValue: ''
	}
}
